export default __webpack_public_path__ + "static/media/image-hero.55c18e98.jpg";